import { useEffect, useMemo, useRef } from 'react';
import { IngredientReportOptionProps } from './ReportsConstants';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { useRMSelector } from 'redux/hooks';
import { selectIsFetchingExperimentData } from 'redux/selectors/ExperimentStateSelector';
import { isNullOrUndefined } from 'utils/Global';

export const useMaxIngredientsOfWell = (
  props: IngredientReportOptionProps,
  setMaxIngredientsWell,
  setMaxIngredients,
) => {
  useEffect(() => {
    if (
      props.docData.plateDto &&
      props.docData.plateDto.every(
        (plate) => !isNullOrUndefined(plate.ingredients?.wellList),
      )
    ) {
      const currentPlate = props.docData.plateDto?.find(
        (plate) => plate.plateId == props.selectedWells[0].plateID,
      );

      let maxIngredients = 0;
      currentPlate.ingredients.wellList.forEach((well) => {
        let currentWellMaxIngredients = 0;
        well.wellLayerList.forEach((lyrList) => {
          currentWellMaxIngredients =
            currentWellMaxIngredients + lyrList.wellLayerIngredientList.length;
        });
        if (currentWellMaxIngredients > maxIngredients) {
          maxIngredients = currentWellMaxIngredients;
        }
      });
      setMaxIngredientsWell(maxIngredients);
      setMaxIngredients(maxIngredients);
    }
  }, [props.docData.plateDto]);
};

export const useExperimentReady = (
  data: ExperimentDtoClient,
  signal?: AbortSignal,
): Promise<ExperimentDtoClient> => {
  const resolveRef = useRef<(arg: ExperimentDtoClient) => void>();
  const rejectRef = useRef<(err: unknown) => void>();
  const isFetchingExpData = useRMSelector(selectIsFetchingExperimentData);

  const promise = useMemo(
    () =>
      new Promise<ExperimentDtoClient>((resolve, reject) => {
        resolveRef.current = resolve;
        rejectRef.current = reject;
      }),
    [],
  );

  // Abort handling
  useEffect(() => {
    if (!signal) {
      return;
    }
    const onAbort = () => rejectRef.current?.({ canceled: true });
    signal.addEventListener('abort', onAbort);
    return () => signal.removeEventListener('abort', onAbort);
  }, [signal]);

  useEffect(() => {
    if (!isFetchingExpData) {
      resolveRef.current?.(data);
    }
  }, [isFetchingExpData]);

  return promise;
};
